import React from 'react';

/**
 * Toggle "Só ativos" reutilizável (Monitores/Automações/Estratégias).
 * props:
 * - checked: boolean
 * - onChange: (boolean) => void
 * - id: string (único na página)
 */
function OnlyActiveToggle(props) {
    const id = props.id || 'onlyActiveToggle';
    return (
        <div className='form-check form-switch d-inline-flex align-items-center me-2' title='Mostrar apenas itens ativos'>
            <input
                className='form-check-input'
                type='checkbox'
                role='switch'
                id={id}
                checked={!!props.checked}
                onChange={e => props.onChange(e.target.checked)}
            />
            <label className='form-check-label ms-2 text-nowrap' htmlFor={id}>Só ativos</label>
        </div>
    );
}

export default OnlyActiveToggle;
